import api from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getVisibilidadeConfiguracao = async (idProcesso, idTipoServico) => {
    let processoSettings = null;
    try {
        const response = await api.get(`Visibilidade/configuracao/${idProcesso}/${idTipoServico}`, config);
        processoSettings = response.data.data;
    } catch (err) { }
    return processoSettings;
}

export const postConfiguracaoCobertura = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/cobertura`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoDocumentos = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/documentos`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoRelogio = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/relogio`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoValores = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/valores`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoVincularRegulacao = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/vincular-regulacao`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoAcionarPericia = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/acionar-pericia`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoAlterarLider = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/alterar-lider`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoAlterarSubLider = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`VisibilidadeConfiguracao/configuracao/acao/alterar-sub-lider`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}

export const postConfiguracaoAlterarStatusOcorrencia = async (data) => {
    let responseData = null;
    try {
        const response = await api.post(`Visibilidade/configuracao/acao/alterar-status-ocorrencia`, data, config);
        responseData = response.data;
    } catch (err) { }
    return responseData;
}